module.exports = __webpack_public_path__ + "img/39c5c6b254d91059512008d05318d82e.png";